export default __webpack_public_path__ + "static/media/jira-long.31ed9c56.svg";